"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorsExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var tinycolor2_1 = tslib_1.__importDefault(require("tinycolor2"));
var _1 = require("@/");
var colors = Object.keys(_1.Colors);
var colorGroups = colors
    .filter(function (color) { return !color.includes('WHITE'); })
    .reduce(function (colorGroup, color, index) {
    var groupIndex = Math.floor(index / 10);
    if (!colorGroup[groupIndex]) {
        colorGroup[groupIndex] = [];
    }
    colorGroup[groupIndex].push(color);
    return colorGroup;
}, []);
var greyScaleColors = colorGroups.slice(0, 2);
var coreColors = colorGroups.slice(2, colorGroups.length);
var ColorsExample = /** @class */ (function () {
    function ColorsExample() {
    }
    ColorsExample.prototype.view = function () {
        return (0, mithril_1.default)('.cui-example-colors', [
            (0, mithril_1.default)('h2', 'Greyscale Colors'),
            this.renderColorGrid(greyScaleColors),
            (0, mithril_1.default)('h2', 'Core colors'),
            this.renderColorGrid(coreColors)
        ]);
    };
    ColorsExample.prototype.renderColorGrid = function (groups) {
        var _this = this;
        var colSpan = {
            xs: 12,
            md: 6,
            sm: 6,
            lg: 4
        };
        return (0, mithril_1.default)(_1.Grid, { gutter: 20 }, groups.map(function (colorGroup) { return [
            (0, mithril_1.default)(_1.Col, { span: colSpan }, [
                (0, mithril_1.default)('.cui-example-colors-group', colorGroup.map(function (color) { return _this.renderColorbar(color); }))
            ])
        ]; }));
    };
    ColorsExample.prototype.renderColorbar = function (color) {
        var style = {
            background: _1.Colors[color],
            color: (0, tinycolor2_1.default)(_1.Colors[color]).isLight() ? 'black' : 'white'
        };
        return (0, mithril_1.default)('.cui-example-colors-bar', { style: style }, [
            (0, mithril_1.default)('', color),
            (0, mithril_1.default)('', _1.Colors[color])
        ]);
    };
    return ColorsExample;
}());
exports.ColorsExample = ColorsExample;
